import {
  SPV_COLUMN_DATA,
  SPV_DATA_REQUEST,
  SPV_CREATE_USER,
  SPV_UPDATE_STATUS,
  SPV_LENGTH_TASK_LIST,
  SPV_MATCH_PROJECT_ID,
  SPV_PAGINATION,
  SPV_OFFSET,
  SPV_GET_NOTIF_TASKLIST,
  SPV_NOTIF_TASKLIST_SUCCESS,
} from "../actions/actionTypes";
import moment from "moment";
import "moment/locale/id";
moment.locale("id");

const initialState = {
  columnDataUser: [
    { title: "User ID", field: "id" },
    {
      title: "Full Name",
      field: "fullname",
    },
    { title: "Username", field: "username" },
    { title: "Email Address", field: "email" },
    {
      title: "Role",
      field: "role",
      lookup: { worker: "Worker", planner: "Planner" },
    },
  ],
  createNewUser: {
    fullname: "",
    username: "",
    email: "",
    password: "",
    role: "",
  },
  columnDataProject: [
    // { title: "No", field: "id" },
    { title: "Project ID", field: "id" },
    { title: "Project Title", field: "title" },
    {
      title: "Start Date",
      field: "start_date",
      render: (rowData) => {
        const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
        let date = new Date(+rowData.start_date);
        return date.toLocaleDateString('id-ID', options);
      },
      // render: (rowData) => moment.unix(rowData.start_date).format("Do MMMM"),
    },
    {
      title: "Due Date",
      field: "due_date",
      render: (rowData) => {
        const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
        let date = new Date(+rowData.due_date);
        return date.toLocaleDateString('id-ID', options);
      },
      // render: (rowData) => moment.unix(rowData.due_date).format("Do MMMM"),
    },
    {
      title: "Status",
      field: "status",
      lookup: {
        submit: "Submit",
        reject: "Reject",
        approve: "Approve",
        return: "Return",
      },
      // lookup: { submit: "submit", reject: "reject", approve: "approve", done: "done", return_to_worker: "return to worker" },
    },
  ],
  columnDataTask: [
    // { title: "No", field: "id" },
    { title: "Project ID", field: "id" },
    { title: "Project Title", field: "title" },
    {
      title: "Start Date",
      field: "start_date",
      // render: (rowData) => moment.unix(rowData.start_date).format("Do MMMM"),
      render: (rowData) => {
        const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
        let date = new Date(+rowData.start_date);
        return date.toLocaleDateString('id-ID', options);
      },

    },
    {
      title: "Due Date",
      field: "due_date",
      render: (rowData) => {
        const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
        let date = new Date(+rowData.due_date);
        return date.toLocaleDateString('id-ID', options);
      },
      // render: (rowData) => moment.unix(rowData.due_date).format("Do MMMM"),
    },
    {
      title: "Status",
      field: "status",
      lookup: {
        complete: "Complete",
        "return to worker": "Return to Worker",
        done: "Done",
      },
    },
  ],
  updateStatusProject: [],
  createNewNote: {
    id: "",
    notes: {
      id: "",
    },
  },
  matchProjectID: "",
  taskList: {
    data: "",
    error: ""
  },
  pagination: {
    currentPage: 0,
    postsPerPage: 10,
    offset: 0
  },
  
};

const spvReducer = (state = initialState, action) => {
  const { payload, type } = action;
  console.log(payload);
  switch (type) {
    case SPV_CREATE_USER:
      return {
        ...state.createNewUser,
        createNewUser: payload,
      };
    case SPV_UPDATE_STATUS:
      return {
        ...state,
        updateStatusProject: payload,
      };
    case SPV_MATCH_PROJECT_ID:
      return {
        ...state,
        matchProjectID: payload,
      };
    // case SPV_LENGTH_TASK_LIST:
    //   return {
    //     ...state,
    //     taskList: payload,
    //   };
    case SPV_NOTIF_TASKLIST_SUCCESS:
      return {
        ...state,
        taskList: {
          data: payload.findAllTaskSupervisor,
        },
      }; 
    case SPV_PAGINATION:
      return {
        ...state.pagination,
        currentPage: payload
      }
      case SPV_OFFSET:
        return {
          ...state.pagination,
          offset: payload,
        };
    case SPV_GET_NOTIF_TASKLIST:
    case SPV_COLUMN_DATA:
    case SPV_DATA_REQUEST:
    default:
      return state;
  }
};

export default spvReducer;
